export var ExternalEscalationType;
(function (ExternalEscalationType) {
    ExternalEscalationType[ExternalEscalationType["CALLBACK"] = 100] = "CALLBACK";
    ExternalEscalationType[ExternalEscalationType["EMAIL"] = 110] = "EMAIL";
})(ExternalEscalationType || (ExternalEscalationType = {}));
;
//# sourceMappingURL=external-escalation-type.enum.js.map